export class ControlTrendEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controlId",
            "baseName": "controlId",
            "type": "string",
            "format": ""
        },
        {
            "name": "trend",
            "baseName": "trend",
            "type": "ComplianceTrend",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlTrendEntry.attributeTypeMap;
    }
    constructor() {
    }
}
